var App = App || {};

App.ComponentTestimonials = (function ($) {
    'use strict';

    function Carousel() {
        $(".component-testimonials").each(function () {
            const carousel = $(this).find(".splide");
             const slides = carousel.find(".splide__list > .splide__slide");

            var splide = new Splide(carousel[0], {
                type: slides.length > 1 ? 'loop' : 'slide',
                gap: "3rem",
                speed: 500
            });

            splide.mount({});
        });
    }

    return {
        Carousel: Carousel
    };

})(jQuery);

$(function () {
    App.ComponentTestimonials.Carousel();
});